import PropTypes from 'prop-types';
import React, { useRef } from 'react';

import { ALL_COLUMNS } from '../constants';
import useInfiniteScroll from '../useInfiniteScroll';
import Cell from './Cell';

const META = Object.fromEntries(ALL_COLUMNS.map((c) => [c.key, c]));

const ArtistTable = ({ rows, visibleColumns, sort, dir, setSort, loading, error, onRetry, hasMore, loadMore }) => {
  const sentinel = useRef(null);
  useInfiniteScroll(sentinel, { hasMore, loading, loadMore });

  const gridTemplate = visibleColumns
    .map((key) => (key === 'artist' ? 'minmax(220px, 2fr)' : 'minmax(90px, 1fr)'))
    .join(' ');

  const onHeaderClick = (col) => {
    if (!col.sortKey) return;
    if (col.sortKey === sort) setSort(col.sortKey, dir === 'asc' ? 'desc' : 'asc');
    else setSort(col.sortKey, 'desc');
  };

  return (
    <div className="ab-table">
      <div className="ab-table__head" style={{ gridTemplateColumns: gridTemplate }}>
        {visibleColumns.map((key) => {
          const col = META[key];
          const active = col.sortKey && col.sortKey === sort;
          return (
            <button
              key={key}
              type="button"
              className={`ab-th ${col.numeric ? 'ab-th--num' : ''} ${col.sortKey ? 'ab-th--sortable' : ''} ${active ? 'ab-th--active' : ''}`}
              onClick={() => onHeaderClick(col)}
            >
              {col.label}
              {active && <span className="ab-th__arrow">{dir === 'asc' ? '↑' : '↓'}</span>}
            </button>
          );
        })}
      </div>

      {rows.map((row) => (
        <div key={row.id} className="ab-tr" style={{ gridTemplateColumns: gridTemplate }}>
          {visibleColumns.map((key) => (
            <div key={key} className={`ab-td ${META[key].numeric ? 'ab-td--num' : ''}`}>
              <Cell colKey={key} row={row} />
            </div>
          ))}
        </div>
      ))}

      {error && rows.length === 0 && (
        <div className="ab-empty ab-empty--table">
          Couldn’t load artists.{' '}
          <button type="button" className="ab-clear" onClick={onRetry}>Retry</button>
        </div>
      )}
      {!error && !loading && rows.length === 0 && (
        <div className="ab-empty ab-empty--table">No artists match these filters.</div>
      )}
      {loading && <div className="ab-empty ab-empty--table">Loading…</div>}
      {hasMore && !error && <div ref={sentinel} className="ab-sentinel" />}
    </div>
  );
};
ArtistTable.propTypes = {
  rows: PropTypes.array.isRequired,
  visibleColumns: PropTypes.array.isRequired,
  sort: PropTypes.string.isRequired,
  dir: PropTypes.string.isRequired,
  setSort: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  error: PropTypes.bool,
  onRetry: PropTypes.func.isRequired,
  hasMore: PropTypes.bool.isRequired,
  loadMore: PropTypes.func.isRequired,
};

export default ArtistTable;
